export const ADMIN_ROUTE_PATTERNS = Object.freeze({
  root: '/admin/*',
  odds: '/admin/odds',
  afrikaShop: '/admin/afrika-shop',
});

export const isAdminPath = (pathname = '') => (
  pathname === '/admin' || pathname.startsWith('/admin/')
);
